// extracted by mini-css-extract-plugin
module.exports = {"lodge":"lodge-module--lodge--3EEJQ","rooms":"lodge-module--rooms--31q4E","fineprint":"lodge-module--fineprint--BnqfE","map":"lodge-module--map--faN4h"};